import { auth } from '../firebase';

/**
 * Panggil layanan luar lewat server sendiri (api/proxy/[name].js), supaya
 * kunci WhaCenter, SumoPod dan API Indonesia tidak ada di browser.
 * Mengembalikan Response apa adanya; pemanggil yang memeriksa `ok`.
 */
export const callProxy = async (name: 'wa' | 'ai' | 'kampus', init: { body?: object; query?: string } = {}): Promise<Response> => {
    const idToken = await auth.currentUser?.getIdToken();
    const headers: Record<string, string> = { Authorization: `Bearer ${idToken || ''}` };
    if (init.body) headers['Content-Type'] = 'application/json';
    return fetch(`/api/proxy/${name}${init.query ? `?${init.query}` : ''}`, {
        method: init.body ? 'POST' : 'GET',
        headers,
        body: init.body ? JSON.stringify(init.body) : undefined,
    });
};

export type WaDevice = 'putra' | 'putri';

/** Kirim WhatsApp lewat WhaCenter: ke nomor pribadi (`number`) atau grup (`group`). */
export const sendWhatsapp = (target: { number?: string; group?: string }, message: string, device: WaDevice = 'putra') =>
    callProxy('wa', {
        body: target.group
            ? { mode: 'group', device, group: target.group, message }
            : { mode: 'send', device, number: target.number, message },
    });
